import useCategories from '../../hooks/use-categories';
export default function MultiselectControl({ value, onChange }) {

    const handleChange = function (e) {

        const item = e.target.id;
        const checked = e.target.checked;

        if (checked) {
            onChange([...value, item]);
        } else {
            onChange(value.filter(i => i !== item));
        }
    };

    const categories = useCategories();
    const categoriesOptions = (Object.keys(categories)).map((key) => {

        return (
            <div key={key} className="checkbox">
                <input id={key} type="checkbox" onChange={handleChange} checked={value.some((i) => i === key)}></input>
                <label htmlFor={key} >{categories[key]}</label>
            </div>);
    });

    return (<div>{categoriesOptions}</div>);

}